//ClientLibsReference
import { Belfastpilatesappspotcom } from "./ClientLibsReference";
var api1 = new Belfastpilatesappspotcom.DefaultApi();

export const api = (name, o) => {
  var opts = {
    body: o
  };
  console.log(`Called API: ${name}`);
  return new Promise((resolve, reject) => {
    var callback = function(error, data, response) {
      if (error) {
        console.log(`[${name}] Got error: ${error}`);
        resolve(error);
      } else {
        resolve({ data });
      }
    };
    api1[name](opts, callback);
  });
};



// WEBPACK FOOTER //
// ./src/common/ApiPromisify.js